export const defaultTaskSortOption = {
  label: 'Due Date',
  value: 'due_or_created_at'
};

const taskSortOptions = [
  defaultTaskSortOption,
  {
    label: 'Oldest',
    value: 'created_at'
  },
  {
    label: 'Newest',
    value: '-created_at'
  }
];

export default taskSortOptions;
